export default {
  bqpReportContent: (state) => state.bqpReportContent,
  bqaReportContent: (state) => state.bqaReportContent,
  bqaRecommendationsReportContent: (state) => state.bqaRecommendationsReportContent,
  reportLoading: (state) => state.reportLoading,
  reportDownloadInfo: (state) => state.reportDownloadInfo,
  recommendationsReportLoading: (state) => state.recommendationsReportLoading,
};
